/**
 * Doodle Doo cart helpers:
 * - keeps the header cart count in sync after AJAX adds
 * - auto-adds the configured freebie product to qualifying carts
 *   (and removes it again if the cart no longer qualifies)
 */
(() => {
  const settings = window.DD_SETTINGS || {};
  let syncing = false;

  const updateCount = (cart) => {
    document.querySelectorAll('[data-dd-cart-count]').forEach((el) => {
      el.textContent = `(${cart.item_count})`;
      el.hidden = cart.item_count === 0;
    });
  };

  const changeFreebie = async (quantity) => {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: settings.freebieVariantId, quantity }),
    });
  };

  const addFreebie = async () => {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: settings.freebieVariantId, quantity: 1 }),
    });
  };

  const sync = async () => {
    if (syncing) return;
    syncing = true;
    try {
      let response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      let cart = await response.json();

      if (settings.freebieVariantId) {
        const freebieLine = cart.items.find((item) => item.variant_id === settings.freebieVariantId);
        const paidSubtotal = cart.items
          .filter((item) => item.variant_id !== settings.freebieVariantId)
          .reduce((sum, item) => sum + item.final_line_price, 0);
        const qualifies = paidSubtotal > 0 && paidSubtotal >= (settings.freebieMinCents || 0);

        if (qualifies && !freebieLine) {
          await addFreebie();
          response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          cart = await response.json();
        } else if (!qualifies && freebieLine) {
          await changeFreebie(0);
          response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          cart = await response.json();
        } else if (freebieLine && freebieLine.quantity > 1) {
          await changeFreebie(1);
          response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
          cart = await response.json();
        }
      }

      updateCount(cart);
    } catch (error) {
      /* network hiccup: leave the cart as-is */
    } finally {
      syncing = false;
    }
  };

  document.addEventListener('dd:cart:changed', sync);
  document.addEventListener('DOMContentLoaded', sync);
})();
